import { MmsServiceInterface } from "interfaces/mms-service"
import React, { createContext, useContext } from "react"

const MmsContext = createContext<MmsServiceInterface | null>(

    null)

const MmsServiceProvider: React.FC<{
    service: MmsServiceInterface
    children: React.ReactNode
}> = ({ service, children }) => (
    <MmsContext.Provider value={service}>{children}</MmsContext.Provider>
)
const useMmsService = () => {
    const context = useContext(MmsContext)
    if (!context) {
        throw new Error(
            "useMmsService must be used within a MmsServiceProvider"
        )
    }
    return context
}

/* eslint react-refresh/only-export-components: off */
export { MmsServiceProvider, useMmsService}
